import type { PickDeep } from 'type-fest'
import type { PlaygameModuleOptions } from '@playgame/types'
import type { PublicPlaygameOptionPath } from '../../publicOptions'
import { useRuntimeConfig } from '#imports'

export const usePlaygameConfig = (): PickDeep<PlaygameModuleOptions, PublicPlaygameOptionPath> => {
    const config = useRuntimeConfig()

    return config.public.playgame as PickDeep<PlaygameModuleOptions, PublicPlaygameOptionPath>
}
